import React from 'react'
import styles from './RefuseModal.module.scss'

const RefuseModal = ({ onClose, onRefuse }) => {
	return (
		<div className={styles.refuseModalContainer}>
			<span className={styles.refuseModalTitle}>제안을 거절하시겠어요?</span>
			<span className={styles.refuseModalDescription}>
				거절한 제안은 다시 취소할 수 없어요.
			</span>
			<div className={styles.refuseAnnouncement}>
				<span>제안 주셔서 감사합니다.</span>
				<span>아쉽게도 이번에는 함께하기 어렵게 되었습니다.</span>
			</div>
			<div className={styles.refuseButtonContainer}>
				<button className={styles.refuseCancelButton} onClick={onClose}>
					취소
				</button>
				<button className={styles.refuseConfirmButton} onClick={onRefuse}>
					거절하기
				</button>
			</div>
		</div>
	)
}

export default RefuseModal
